import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=ea3db444&scoped=true"
import script from "./CategoryPreview.vue?vue&type=script&lang=js"
export * from "./CategoryPreview.vue?vue&type=script&lang=js"
import style0 from "./CategoryPreview.vue?vue&type=style&index=0&id=ea3db444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3db444",
  null
  
)

export default component.exports